import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ozonwerte',
  templateUrl: './ozonwerte.component.html',
  styleUrls: ['./ozonwerte.component.css']
})
export class OzonwerteComponent {


}
